import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { fetchSchedule } from '../../../actions/appointments';
import { fetchActivities } from "../../../actions/configs";
import viewHelper from '../../../helpers/view';
import SelectActivity from '../selectActivity';
import SelectDate from './selectDate';
import SelectClass from './selectClass';
import Confirm from './confirm';
import Spinner from '../../shared/spinner';
import MemberInfo from "../../shared/memberInfo";
import CONSTANTS from "../../../constants";

class Schedule extends Component {

    constructor(props) {
        super(props);
        this.state = { activity: null, startDate: null, endDate: null, class: null, confirm: false };
    }

    componentDidMount() {
        this.props.fetchActivities(true, this.getBusinessName(), {filter: 'class'});
    }

    getBusinessName() {
        return this.props.match.params.bname;
    }

    updateComponent(state) {
        return this.setState(state, () => {
            if(this.state.activity && this.state.startDate && this.state.class && this.state.confirm) {
                // Do nothing
            } else if (state.startDate) {
                this.props.fetchSchedule(this.getBusinessName(), {activity_id: this.state.activity.id, start_date: this.state.startDate, end_date: this.state.endDate});
            }
        });
    }

    selectActivity() {
        this.setState({ activity: null, startDate: null, endDate: null, class: null, confirm: false });
    }

    selectDate() {
        this.setState({ activity: this.state.activity, startDate: null, endDate: null, class: null, confirm: false });
    }

    selectClass() {
        this.setState({ activity: this.state.activity, startDate: this.state.startDate, endDate: this.state.endDate, class: null, confirm: false });
    }

    getSelectedComponent() {
        if(!this.state.activity) {
          return SelectActivity;
        } else if (this.state.activity && !this.state.startDate){
            return SelectDate;
        } else if (this.state.startDate && !this.props.classes) {
            return Spinner;
        } else if (this.props.classes && !this.state.class) {
            return SelectClass;
        } else if (this.state.class && !this.state.confirm) {
            return Confirm;
        }
    }

    getActivityTitle() {
        let title;
        if(this.state.activity) {
            title = <div className='selection small cursor' onClick={this.selectActivity.bind(this)}>{this.state.activity.description}</div>;
        } else {
            title = <div className='selection small'>Selecting Service</div>;
        }

        return (
            <div className='step-title'>
                <div className='header'>1. Service</div>
                {title}
            </div>
        );
    }

    getDateTitle(currentStep) {
        let title;
        if(this.state.startDate) {
            title = <div className='selection small cursor' onClick={this.selectDate.bind(this)}>{viewHelper.getFormattedDate(this.state.startDate, CONSTANTS.DATE.FORMAT.DEFAULT)}</div>;
        } else {
            title = currentStep ? <div className='selection small'>Selecting Date</div> : '';
        }
        return (
            <div className='step-title'>
                <div className='header'>2. Date</div>
                {title}
            </div>
        );
    }

    getClassTitle(currentStep) {
        let title;
        if(this.state.class) {
            title = <div className='selection small cursor' onClick={this.selectClass.bind(this)}>{this.state.class.activity_name} {this.state.class.class_name ? `: ${this.state.class.class_name}` : ''} with {this.state.class.trainer_name} </div>;
        } else {
            title = currentStep ? <div className='selection small'>Selecting Class</div> : '';
        }
        return (
            <div className='step-title'>
                <div className='header'>3. Class</div>
                {title}
            </div>
        );
    }

    getConfirmationTitle(currentStep) {
        let title;
        if(this.state.confirm) {
            title = <div className='selection small'>Confirmed</div>;
        } else {
            title = currentStep ? <div className='selection small'>Confirm Your Selections</div> : '';
        }
        return (
            <div className='step-title'>
                <div className='header'>4. Confirm</div>
                {title}
            </div>
        );
    }

    render () {
        let SelectedComponent = this.getSelectedComponent();
        if (SelectedComponent) {
            return (
                <div className="container content">
                    <MemberInfo title='Class Schedule - Sign Up For Class ' />

                    <div className="col-xs-12 col-md-12 col-lg-12 no-padding">
                        <div className="row-eq-height">
                            <div className="col-xs-12 col-md-3 col-lg-3 filters steps">
                                <div className="col-md-12 col-sm-6 col-xs-12">
                                    <blockquote className="active">{this.getActivityTitle(!this.state.activity)}</blockquote>
                                </div>
                                <div className="col-md-12 col-sm-6 col-xs-12">
                                    <blockquote className={this.state.activity ? 'active' : ''}>{this.getDateTitle(this.state.activity)}</blockquote>
                                </div>
                                <div className="col-md-12 col-sm-6 col-xs-12">
                                    <blockquote className={this.state.startDate ? 'active' : ''}>{this.getClassTitle(this.state.startDate)}</blockquote>
                                </div>
                                <div className="col-md-12 col-sm-6 col-xs-12">
                                    <blockquote className={this.state.class ? 'active' : ''}>{this.getConfirmationTitle(this.state.class)}</blockquote>
                                </div>
                                <div className='col-md-12 small col-xs-12'>*You Can Edit Your Selections At Any Step By Clicking On It.</div>
                            </div>
                            <div className="col-xs-12 col-md-9 col-lg-9 no-padding pt-15 pb-15 border-bottom">
                                <SelectedComponent {...this.state}
                                                   activities={this.props.activities}
                                                   classes={this.props.classes}
                                                   callbackToUpdateComponent={this.updateComponent.bind(this)} />
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return <Redirect to={{ pathname: `/${this.getBusinessName()}/appointments/${this.state.class.id}/${this.state.activity.id}/sign_up`, state: { from: this.props.location } }} />;
        }
    }
}

function mapStateToProps(state) {
    const classes = state.schedule;
    const {activities} = state;
    return { classes, activities };
}

export default connect(mapStateToProps, { fetchSchedule, fetchActivities })(Schedule);
